import React from "react";
import "../styles/drawer.css";
import { Drawer, ButtonToolbar, Button, Sidenav, Nav } from "rsuite";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@rsuite/icons/Menu";
let aboutus = [
  {
    title: "Who We Are",
    path: "/aboutus",
  },
  {
    title: "Where We Work",
    path: "/wherewework",
  },
  {
    title: "History / Milestone",
    path: "/historymilestone",
  },
  {
    title: "Accountability",
    path: "/accountability",
  },
  {
    title: "Complaints & Feedback",
    path: "/complaintform",
  },
  {
    title: "Our Team",
    path: "/ourteam",
  },
  {
    title: "FAQs",
    path: "/faq",
  },
];

let whatwedo = [
  {
    title: "Overview",
    path: "/overview",
  },
  {
    title: "KRO Programming Approaches",
    path: "/programmingapproaches",
  },
  {
    title: "Livelihood & Food Security",
    path: "/livelihoodfoodsecurity",
  },
  {
    title: "WASH",
    path: "/wash",
  },
  {
    title: "Cash-based Interventions",
    path: "/cashbasedinterventions",
  },
  {
    title: "Protection",
    path: "/protection",
  },
  {
    title: "Shelter",
    path: "/shelter",
  },
  {
    title: "SBC",
    path: "/sbc",
  },
  {
    title: "Child Protection",
    path: "/childprotection",
  },
];

let media = [
  {
    title: "News Letter",
    path: "/newsletter",
  },
  {
    title: "Success Stories",
    path: "/successstories",
  },
  {
    title: "Photo Gallery",
    path: "/photogallery",
  },
  {
    title: "Video Gallery",
    path: "/videogallery",
  },
];

const NavDrawer = ({ transparent }) => {
  const [open, setOpen] = React.useState(false);
  let navigate = useNavigate();

  const GoTo = (item) => {
    setOpen(false);
    navigate(item);
  };

  return (
    <>
      <ButtonToolbar>
        <Button
          onClick={() => setOpen(true)}
          appearance="ghost"
          style={{
            border: "1px solid #c6c662",
            color: "#c6c662",
            width: "50px",
          }}
        >
          <MenuIcon style={{ fontSize: "20px" }} />
        </Button>
      </ButtonToolbar>

      <Drawer
        size="xs"
        style={{ width: "100%" }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Drawer.Header>
          <Drawer.Title>Navigation</Drawer.Title>
          <Drawer.Actions></Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
          <div
            style={{
              width: "100%",
              height: "100% !important",
              paddingBottom: "270px",
              overflowY: "scroll !important",
            }}
          >
            <Sidenav defaultOpenKeys={["1"]}>
              <Sidenav.Body>
                <Nav>
                  <Nav.Menu eventKey="1" title="About Us">
                    {aboutus.map((item, i) => (
                      <Nav.Item
                        eventKey={i + 1}
                        onClick={() => GoTo(item.path)}
                      >
                        {item.title}
                      </Nav.Item>
                    ))}
                  </Nav.Menu>
                  <Nav.Menu eventKey="2" title="What We Do">
                    {whatwedo.map((item, i) => (
                      <Nav.Item
                        eventKey={i + 1}
                        onClick={() => GoTo(item.path)}
                      >
                        {item.title}
                      </Nav.Item>
                    ))}
                  </Nav.Menu>
                  <Nav.Menu eventKey="3" title="Get Involved">
                    <Nav.Item
                      eventKey="3-1"
                      onClick={() => GoTo("/careeropportunities")}
                    >
                      Career Opportunities
                    </Nav.Item>
                    <Nav.Item eventKey="3-2" onClick={() => GoTo("/rfps")}>
                      RFQs & RFPs
                    </Nav.Item>
                  </Nav.Menu>
                  <Nav.Menu eventKey="4" title="Media">
                    {media.map((item, i) => (
                      <Nav.Item
                        eventKey={i + 1}
                        onClick={() => GoTo(item.path)}
                      >
                        {item.title}
                      </Nav.Item>
                    ))}
                  </Nav.Menu>
                  <Nav.Item onClick={() => GoTo("/impact")}>Impact</Nav.Item>
                  <Nav.Item onClick={() => GoTo("/contactus")}>
                    Contact Us
                  </Nav.Item>
                </Nav>
              </Sidenav.Body>
            </Sidenav>
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default NavDrawer;
